enum BlockTheme {
  light,
  dark,
}
export type BackgroundColorWithMode = { color: string; mode: BlockTheme };

export enum BackgroundColors {
  neutralLight = "neutralLight",
  neutral = "neutral",
  darkest = "darkest",
  mainCTA = "mainCTA",
  dark = "dark",
  secondaryCTA = "secondaryCTA",
  none = "none",
}

export const backgroundColorModeMapper = (
  color: string
): BackgroundColorWithMode => {
  switch (color) {
    case "neutral":
    case "_neutral":
      return {
        color: "variables._neutral",
        mode: BlockTheme.light,
      };
    case "mainCTA":
    case "maincta":
    case "_mainCTA":
    case "_maincta":
      return {
        color: "variables._mainCTA",
        mode: BlockTheme.light,
      };
    case "secondaryCTA":
    case "secondarycta":
    case "_secondaryCTA":
    case "_secondarycta":
      return {
        color: "variables._secondaryCTA",
        mode: BlockTheme.light,
      };
    case "dark":
    case "_dark":
      return {
        color: "variables._dark",
        mode: BlockTheme.dark,
      };
    case "darkest":
    case "_darkest":
      return {
        color: "variables._darkest",
        mode: BlockTheme.dark,
      };
    case "none":
      return {
        color: "none",
        mode: BlockTheme.dark,
      };
    default:
      return {
        color: "variables._neutralLight",
        mode: BlockTheme.light,
      };
  }
};
